import { useEffect } from 'react';
import ContactBreadCumb from '../components/contacts/ContactBreadCumb';
import ContactForm from '../components/contacts/ContactForm';
import NewsLetter from '../components/NewsLetter';


function ContactPage() {
	useEffect(() => {
	  window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);
	
  return (
	  <main>
	  <ContactBreadCumb/>
	  <ContactForm/>
	  <NewsLetter/>
	  
	  </main>

  )
}

export default ContactPage;
